import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { IconButton, Menu, MenuItem, withStyles } from '@material-ui/core'
import { MoreHoriz, MoreVert, Delete, Edit } from '@material-ui/icons'
import { toggleDeleteDialog } from 'actions/view'
import { toggleTaskModal } from 'actions/campaign/addOrEdit'
import language from 'utils/vast-languagepack'

export default connect(null, (dispatch) =>
  bindActionCreators({ toggleDeleteDialog, toggleTaskModal }, dispatch),
)(
  withStyles((theme) => ({
    expandPanelDetailsIconSecondary: {
      position: 'absolute',
      right: '8px',
      top: '67%',
    },
    leftIcon: {
      marginRight: theme.spacing.unit,
      fill: theme.palette.text.secondary,
    },
    root: {
      [theme.breakpoints.down('sm')]: {
        padding: 4,
      },
    },
  }))(
    class SimpleMenu extends Component {
      state = {
        anchorEl: null,
      }

      handleClick = (event) => {
        this.setState({ anchorEl: event.currentTarget })
      }

      handleClose = () => {
        this.setState({ anchorEl: null })
      }

      handleDeleteClick = () => {
        this.setState({ anchorEl: null })
        this.props.toggleDeleteDialog({
          id: this.props.task.id,
          name: this.props.task.name,
          entityType: 'task',
          entity: this.props.task,
        })
      }

      render() {
        const { anchorEl } = this.state
        const {
          classes,
          horiz,
          vert,
          taskID,
          expanded,
          idx,
          task,
          toggleTaskModal,
        } = this.props

        return (
          <div>
            <IconButton
              aria-owns={anchorEl ? `deleteMenu${taskID}` : undefined}
              aria-haspopup="true"
              onClick={this.handleClick}
              style={
                horiz
                  ? {
                      display: expanded === idx ? 'inline-flex' : 'none',
                    }
                  : vert
                  ? { position: 'absolute', top: 0, right: 0 }
                  : null
              }
              className={horiz ? classes.expandPanelDetailsIconSecondary : null}
              classes={{ root: classes.root }}
            >
              {horiz ? <MoreHoriz /> : null}
              {vert ? <MoreVert /> : null}
            </IconButton>
            <Menu
              id={`deleteMenu${taskID}`}
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={this.handleClose}
            >
              <MenuItem onClick={() => toggleTaskModal(task)}>
                <Edit className={classes.leftIcon} />
                {language.task.add.edit}
              </MenuItem>
              <MenuItem onClick={this.handleDeleteClick}>
                <Delete className={classes.leftIcon} />
                {language.task.add.delete}
              </MenuItem>
            </Menu>
          </div>
        )
      }
    },
  ),
)
